var app = angular.module('CarsSaraBo');
app.constant('Constants', {
    states: {
        ACCEPTED: 'ACCEPTED',
        TACITLY_ACCEPTED: 'TACITLY_ACCEPTED',
        PENDING: 'PENDING',
        INVALIDATED: 'INVALIDATED',
        DISPUTED: 'DISPUTED',
        EXPIRED: 'EXPIRED',
        CREATED: 'CREATED'
    }
});
app.factory('ContractStatesService', ['Constants','NotificationService', function (Constants,notificationService) {
    return {

        isINVALIDATED : function(state){
            return state === Constants.states.INVALIDATED;
        },

        isPENDING : function(state){
            return state === Constants.states.PENDING;
        },

        isDISPUTED : function(state){
            return state === Constants.states.DISPUTED;
        },

        isTACITLYACCEPTED : function(state){
            return state === Constants.states.TACITLY_ACCEPTED;
        },

        isCREATED : function(state){
            return state === Constants.states.CREATED;
        },

        isACCEPTED : function(state){
            return state === Constants.states.ACCEPTED;
        },

        getColorByState : function(term){
            //state CREATED is a not visible state
            var color = '#000000';
            if(term){
                switch (term.state) {
                    case Constants.states.ACCEPTED: color = '#00b02e'; break;
                    case Constants.states.TACITLY_ACCEPTED: color = '#0050d0'; break;
                    case Constants.states.PENDING: color = '#FA8E04'; break;
                    case Constants.states.INVALIDATED: color = '#EB1B00'; break;
                    case Constants.states.DISPUTED: color = '#FFC005'; break;
                    case Constants.states.EXPIRED: color = '#888888'; break;
                }
            }
            return 'color:' + color;
        },

        getIconColorMessageByState : function(term){
            var color = 'color-icon-state-accepted';
            if(term){
                switch (term.state) {
                    case Constants.states.ACCEPTED: color = 'color-icon-state-accepted'; break;
                    case Constants.states.TACITLY_ACCEPTED: color = 'color-icon-state-auto-accepted'; break;
                    case Constants.states.PENDING: color = 'color-icon-state-pending'; break;
                    case Constants.states.INVALIDATED: color = 'color-icon-state-invalidated'; break;
                    case Constants.states.DISPUTED: color = 'color-icon-state-disputed'; break;
                    case Constants.states.EXPIRED: color = 'color-icon-state-expired'; break;
                }
            }
            return 'color:' + color;
        },

        getTextColorMessageByState : function(term){
            var color = 'color-txt-state-accepted';
            if(term){
                switch (term.state) {
                    case Constants.states.ACCEPTED: color = 'color-txt-state-accepted'; break;
                    case Constants.states.TACITLY_ACCEPTED: color = 'color-txt-state-auto-accepted'; break;
                    case Constants.states.PENDING: color = 'color-txt-state-pending'; break;
                    case Constants.states.INVALIDATED: color = 'color-txt-state-invalidated'; break;
                    case Constants.states.DISPUTED: color = 'color-txt-state-disputed'; break;
                    case Constants.states.EXPIRED: color = 'color-txt-state-expired'; break;
                }
            }
            return color;
        },

        getIconMessageByState : function(term){
            var icon = 'info-circle';
            if(term){
                switch (term.state) {
                    case Constants.states.ACCEPTED: icon = 'checkmark-circle'; break;
                    case Constants.states.TACITLY_ACCEPTED: icon = 'info-circle'; break;
                    case Constants.states.PENDING: icon = 'info-circle'; break;
                    case Constants.states.INVALIDATED: icon = 'info-circle'; break;
                    case Constants.states.DISPUTED: icon = 'info-circle'; break;
                    case Constants.states.EXPIRED: icon = 'warning'; break;
                }
            }
            return 'eva-3-icon-' + icon;
        },

        getColorMessageByState : function(term){
            //state CREATED is a not visible state
            var color = 'color-msg-state-accepted';
            if(term){
                switch (term.state) {
                    case Constants.states.ACCEPTED: color = 'color-msg-state-accepted'; break;
                    case Constants.states.TACITLY_ACCEPTED: color = 'color-msg-state-auto-accepted'; break;
                    case Constants.states.PENDING: color = 'color-msg-state-pending'; break;
                    case Constants.states.INVALIDATED: color = 'color-msg-state-invalidated'; break;
                    case Constants.states.DISPUTED: color = 'color-msg-state-disputed'; break;
                    case Constants.states.EXPIRED: color = 'color-msg-state-expired'; break;
                }
            }
            return color;
        },

        showMessageBanner : function(state){
            return state === Constants.states.EXPIRED;
        },


        showNotification : function(state, daysPassedSinceLastModification){
            if(this.isPENDING(state)){
                var keyText = "";

                if(daysPassedSinceLastModification == 0){
                    keyText = 'pending_init';

                }else if(daysPassedSinceLastModification == 5){
                    keyText = 'pending_ten_days_left';

                }else if(daysPassedSinceLastModification == 14){
                    keyText = 'pending_one_day_left';
                }

                if(keyText && keyText !== ''){
                    notificationService.showToast('contract.terms.toast.title.' + keyText, 'contract.terms.toast.message.' + keyText, null,'INFO',10000);
                }

            }else if(this.isTACITLYACCEPTED(state)){
                notificationService.showToast('contract.terms.toast.title.accepted_auto', 'contract.terms.toast.message.accepted_auto', null,'INFO',10000);

            }else if(this.isINVALIDATED(state)){
                notificationService.showToast('contract.terms.toast.title.invalidated', 'contract.terms.toast.message.invalidated', null,'INFO',10000);
            }
        },
        INVALIDATED : function(){
            return Constants.states.INVALIDATED;
        },

        PENDING : function(){
            return Constants.states.PENDING;
        },

        DISPUTED : function(){
            return Constants.states.DISPUTED;
        },

        TACITLYACCEPTED : function(){
            return Constants.states.TACITLY_ACCEPTED;
        },

        CREATED : function(){
            return Constants.states.CREATED;
        },

        ACCEPTED : function(){
            return Constants.states.ACCEPTED;
        },


    }
}]);








//////////////////
// WEBPACK FOOTER
// ./public/app/contract/contract_states_services.js
// module id = 921
// module chunks = 3